<template>
  <div v-for="(item, index) in founder" :key="index" class="mt-3">
    <div class="row">
      <div class="col-auto">
        <div class="form-group mb-3">
          <label :for="'founderFL' + index">
            <input
              type="radio"
              :name="'founder' + index"
              :id="'founderFL' + index"
              :checked="item.type == 'fl'"
              @change="() => onTypeChange(index, 'fl')"
              :disabled="disabled"
            />
            <span>Физическое лицо</span>
          </label>
        </div>
      </div>

      <div class="col-auto">
        <div class="form-group mb-3">
          <label :for="'founderUL' + index">
            <input
              type="radio"
              :name="'founder' + index"
              :id="'founderUL' + index"
              :checked="item.type == 'ul'"
              @change="() => onTypeChange(index, 'ul')"
              :disabled="disabled"
            />
            <span>Юридическое лицо</span>
          </label>
        </div>
      </div>
    </div>

    <div class="row" v-if="item.type == 'fl'">
      <div class="col-md-8 col-lg-6">
        <!-- <ui-input-box-floating class="mb-3" :error="item.errors?.FounderFLLName">
                    <ui-input v-model="item.FounderFLLName" type="text" placeholder="Фамилия учредителя"
                        :disabled="disabled" />
                    <ui-input-label>Фамилия учредителя</ui-input-label>
                </ui-input-box-floating> -->

        <Autocomplete
          class="mb-3"
          v-model="item.FounderFLLName"
          type="fio"
          label="Фамилия учредителя"
          :payload="{ parts: ['SURNAME'] }"
          placeholder="Фамилия учредителя"
          :error="item.errors?.FounderFLLName"
          :disabled="disabled"
          @select="(d) => (item.FounderFLLName = d.value)"
        />

        <div class="row">
          <div class="col-md-6">
            <!-- <ui-input-box-floating class="mb-3" :error="item.errors?.FounderFLFName">
                            <ui-input v-model="item.FounderFLFName" type="text" placeholder="Имя учредителя"
                                :disabled="disabled" />
                            <ui-input-label>Имя учредителя</ui-input-label>
                        </ui-input-box-floating> -->

            <Autocomplete
              class="mb-3"
              v-model="item.FounderFLFName"
              type="fio"
              label="Имя учредителя"
              :payload="{ parts: ['NAME'] }"
              placeholder="Имя учредителя"
              :error="item.errors?.FounderFLFName"
              :disabled="disabled"
              @select="(d) => (item.FounderFLFName = d.value)"
            />
          </div>

          <div class="col-md-6">
            <!-- <ui-input-box-floating class="mb-3" :error="item.errors?.FounderFLMName">
                            <ui-input v-model="item.FounderFLMName" type="text" placeholder="Отчество учредителя"
                                :disabled="disabled" />
                            <ui-input-label>Отчество учредителя</ui-input-label>
                        </ui-input-box-floating> -->

            <Autocomplete
              class="mb-3"
              v-model="item.FounderFLMName"
              type="fio"
              label="Отчество учредителя"
              :payload="{ parts: ['PATRONYMIC'] }"
              placeholder="Отчество учредителя"
              :error="item.errors?.FounderFLMName"
              :disabled="disabled"
              @select="(d) => (item.FounderFLMName = d.value)"
            />
          </div>

          <div class="col-md-6">
            <ui-input-box-floating
              class="mb-3"
              :error="item.errors?.FounderFLBD"
            >
              <ui-input
                v-model="item.FounderFLBD"
                type="date"
                placeholder="Дата рождения"
                :disabled="disabled"
              />
              <ui-input-label>Дата рождения</ui-input-label>
            </ui-input-box-floating>
          </div>

          <div class="col-md-6">
            <!-- <ui-input-box-floating class="mb-3" :error="item.errors?.FounderFLBPlace">
                            <ui-input v-model="item.FounderFLBPlace" type="text" placeholder="Место рождения"
                                :disabled="disabled" />
                            <ui-input-label>Место рождения</ui-input-label>
                        </ui-input-box-floating> -->

            <Autocomplete
              class="mb-3"
              v-model="item.FounderFLBPlace"
              type="address"
              label="Место рождения"
              placeholder="Место рождения"
              :error="item.errors?.FounderFLBPlace"
              :disabled="disabled"
              @select="(d) => (item.FounderFLBPlace = d.value)"
            />
          </div>
        </div>

        <ui-input-box-floating class="mb-3" :error="item.errors?.FounderFLINN">
          <ui-input
            v-model="item.FounderFLINN"
            type="text"
            placeholder="ИНН"
            :disabled="disabled"
          />
          <ui-input-label>ИНН</ui-input-label>
        </ui-input-box-floating>

        <h5>Участие в капитале</h5>

        <ui-input-box-floating
          class="mb-3"
          :error="item.errors?.FounderFLShare"
        >
          <ui-input
            v-model="item.FounderFLShare"
            type="number"
            placeholder="Доля %"
            :disabled="disabled"
          />
          <ui-input-label>Доля %</ui-input-label>
        </ui-input-box-floating>

        <div class="form-group mb-3">
          <label>
            <input
              v-model="item.FounderFLIsBeneficiary"
              type="checkbox"
              name="FounderFLIsBeneficiary"
              :disabled="disabled"
            />
            <span>Является бенефициаром</span>
          </label>
        </div>

        <div class="form-group mb-3">
          <label>
            <input
              v-model="item.FounderFLPDL"
              type="checkbox"
              name="FounderFLPDL"
              :disabled="disabled"
            />
            <span>Является публичным должностным лицом</span>
          </label>
        </div>
      </div>

      <div class="col-md-8 col-lg-6">
        <h5>Паспорт</h5>

        <ui-input-box-floating
          class="mb-3"
          :error="item.errors?.FounderFLCitizenship"
        >
          <select
            v-model="item.FounderFLCitizenship"
            class="form-control form-select"
            :disabled="disabled"
          >
            <option value="Российская Федерация">Российская Федерация</option>
            <option value="Иностранный гражданин">Иностранный гражданин</option>
          </select>
          <ui-input-label>Гражданство</ui-input-label>
        </ui-input-box-floating>

        <ui-input-box-floating
          class="mb-3"
          :error="item.errors?.FounderFLPassportSN"
        >
          <ui-input
            v-model="item.FounderFLPassportSN"
            type="text"
            placeholder="Серия и номер паспорта"
            :disabled="disabled"
          />
          <ui-input-label>Серия и номер паспорта</ui-input-label>
        </ui-input-box-floating>

        <!-- <ui-input-box-floating class="mb-3" :error="item.errors?.FounderFLPassPlace">
                    <ui-input v-model="item.FounderFLPassPlace" type="text" placeholder="Место выдачи"
                        :disabled="disabled" />
                    <ui-input-label>Место выдачи</ui-input-label>
                </ui-input-box-floating> -->

        <Autocomplete
          class="mb-3"
          v-model="item.FounderFLPassPlace"
          type="fms_unit"
          label="Место выдачи"
          placeholder="Место выдачи"
          :error="item.errors?.FounderFLPassPlace"
          :disabled="disabled"
          @select="
            (d) => {
              item.FounderFLPassPlace = d.value;
              item.FounderFLPassPCode = d.data.code || '';
            }
          "
        />

        <div class="row">
          <div class="col-md-6">
            <ui-input-box-floating
              class="mb-3"
              :error="item.errors?.FounderFLPassDate"
            >
              <ui-input
                v-model="item.FounderFLPassDate"
                type="date"
                placeholder="Дата выдачи"
                :disabled="disabled"
              />
              <ui-input-label>Дата выдачи</ui-input-label>
            </ui-input-box-floating>
          </div>

          <div class="col-md-6">
            <ui-input-box-floating
              class="mb-3"
              :error="item.errors?.FounderFLPassPCode"
            >
              <ui-input
                v-model="item.FounderFLPassPCode"
                type="text"
                placeholder="Код подразделения"
                :disabled="disabled"
              />
              <ui-input-label>Код подразделения</ui-input-label>
            </ui-input-box-floating>
          </div>
        </div>

        <!-- <ui-input-box-floating class="mb-3" :error="item.errors?.FounderFLRegistration">
                    <ui-input v-model="item.FounderFLRegistration" type="text" placeholder="Адрес регистрации"
                        :disabled="disabled" />
                    <ui-input-label>Адрес регистрации</ui-input-label>
                </ui-input-box-floating> -->

        <Autocomplete
          class="mb-3"
          v-model="item.FounderFLRegistration"
          type="address"
          label="Адрес регистрации"
          placeholder="Адрес регистрации"
          :error="item.errors?.FounderFLRegistration"
          :disabled="disabled"
          @select="(d) => (item.FounderFLRegistration = d.value)"
        />
      </div>
    </div>

    <div class="row" v-if="item.type == 'ul'">
      <div class="col-md-8 col-lg-6">
        <!-- <ui-input-box-floating class="mb-3" :error="item.errors?.FounderULINN">
                    <ui-input v-model="item.FounderULINN" type="text" placeholder="ИНН" :disabled="disabled" />
                    <ui-input-label>ИНН</ui-input-label>
                </ui-input-box-floating> -->

        <Autocomplete
          class="mb-3"
          v-model="item.FounderULINN"
          type="party"
          label="ИНН"
          placeholder="ИНН"
          :error="item.errors?.FounderULINN"
          :disabled="disabled"
          @select="
            (d) => {
              item.FounderULINN = d.data.inn || '';
              item.FounderULIOGRN = d.data.ogrn || '';
              item.FounderULName = d.value || '';
            }
          "
        />

        <!-- <ui-input-box-floating class="mb-3" :error="item.errors?.FounderULIOGRN">
                    <ui-input v-model="item.FounderULIOGRN" type="text" placeholder="ОГРН" :disabled="disabled" />
                    <ui-input-label>ОГРН</ui-input-label>
                </ui-input-box-floating> -->

        <Autocomplete
          class="mb-3"
          v-model="item.FounderULIOGRN"
          type="party"
          label="ОГРН"
          placeholder="ОГРН"
          :error="item.errors?.FounderULIOGRN"
          :disabled="disabled"
          @select="
            (d) => {
              item.FounderULINN = d.data.inn || '';
              item.FounderULIOGRN = d.data.ogrn || '';
              item.FounderULName = d.value || '';
            }
          "
        />

        <!-- <ui-input-box-floating class="mb-3" :error="item.errors?.FounderULName">
                    <ui-input v-model="item.FounderULName" type="text" placeholder="Наименование ЮЛ"
                        :disabled="disabled" />
                    <ui-input-label>Наименование ЮЛ</ui-input-label>
                </ui-input-box-floating> -->

        <Autocomplete
          class="mb-3"
          v-model="item.FounderULName"
          type="party"
          label="Наименование ЮЛ"
          placeholder="Наименование ЮЛ"
          :error="item.errors?.FounderULName"
          :disabled="disabled"
          @select="
            (d) => {
              item.FounderULINN = d.data.inn || '';
              item.FounderULIOGRN = d.data.ogrn || '';
              item.FounderULName = d.value || '';
            }
          "
        />
      </div>

      <div class="col-md-8 col-lg-6">
        <h5>Участие в капитале</h5>

        <ui-input-box-floating
          class="mb-3"
          :error="item.errors?.FounderULShare"
        >
          <ui-input
            v-model="item.FounderULShare"
            type="number"
            placeholder="Доля %"
            :disabled="disabled"
          />
          <ui-input-label>Доля %</ui-input-label>
        </ui-input-box-floating>
      </div>
    </div>

    <button
      @click="() => del(index)"
      class="btn btn-ghost btn-small mb-2"
      :disabled="founder.length == 1 || disabled"
    >
      Удалить учредителя
    </button>
  </div>

  <button @click="add" class="btn btn-base btn-small mb-3" :disabled="disabled">
    Добавить учредителя
  </button>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";

import Autocomplete from "../../../component/Autocomplete/index.vue";

const props = defineProps({
  data: {
    type: Object,
    default: {},
  },
  errors: {
    type: Object,
    default: {},
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const founder = ref([]);

const add = () => {
  founder.value = [
    ...founder.value,
    { type: "fl", FounderFLCitizenship: "Российская Федерация" },
  ];
};

const del = (index) => {
  founder.value = founder.value.filter(
    (item, itemIndex) => itemIndex !== index
  );
};

const onTypeChange = (index, newType) => {
  founder.value[index] = {
    type: newType,
    FounderFLCitizenship: newType == "fl" && "Российская Федерация",
  };
};

const founderLoading = ref(false);

onMounted(async () => {
  if (props.data?.FounderFL?.length > 0 || props.data?.FounderUL?.length > 0) {
    const FounderFL =
      props.data?.FounderFL?.length > 0
        ? props.data.FounderFL.map((item) => ({ ...item, type: "fl" }))
        : [];

    const FounderUL =
      props.data?.FounderUL?.length > 0
        ? props.data.FounderUL.map((item) => ({ ...item, type: "ul" }))
        : [];

    founder.value = [...FounderFL, ...FounderUL];
  } else {
    founder.value = [
      { type: "fl", FounderFLCitizenship: "Российская Федерация" },
    ];
  }

  founderLoading.value = true;
});

watch(
  founder,
  (newValue) => {
    if (founderLoading.value) {
      const FounderFL = newValue
        .filter((item) => item.type === "fl")
        .map(({ type, ...rest }) => rest);
      const FounderUL = newValue
        .filter((item) => item.type === "ul")
        .map(({ type, ...rest }) => rest);

      const cleanFounderFL = FounderFL.map((item) => {
        const { errors, ...rest } = item;
        return rest;
      });

      const cleanFounderUL = FounderUL.map((item) => {
        const { errors, ...rest } = item;
        return rest;
      });

      // Сохраняем очищенные данные
      props.data.FounderFL = cleanFounderFL;
      props.data.FounderUL = cleanFounderUL;
    }
  },
  { deep: true }
);

watch(
  () => props.errors,
  (newErrors) => {
    const FounderFLErrors = newErrors?.FounderFL || [];
    const FounderULErrors = newErrors?.FounderUL || [];

    let flIndex = 0;
    let ulIndex = 0;

    founder.value = founder.value.map((item) => {
      if (item.type === "fl") {
        return {
          ...item,
          errors: FounderFLErrors[flIndex++] || {},
        };
      } else if (item.type === "ul") {
        return {
          ...item,
          errors: FounderULErrors[ulIndex++] || {},
        };
      }
      return item;
    });

    // остальная логика
  },
  { deep: true, immediate: true }
);
</script>